/* eslint-disable no-nested-ternary */
/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { withRouter } from 'react-router';
import Radio from '@material-ui/core/Radio';
import MenuItem from '@material-ui/core/MenuItem';
import TextField from '@material-ui/core/TextField';
import { Button, Tooltip } from 'react-bootstrap';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import TableGrid from '../../../../SharedModules/Table/TableGridWithFeatures';
import DisplayErrorMessages from '../../../../SharedModules/Errors/ErrorMessages';
import SVGComponent from '../../../../SharedModules/SVGComponents/SVGComponents';
import {
  FAILED_MESSAGE_GENERIC,
  NO_RESULT_FOUND_ERROR,
  SEARCH_FOR_FIELD_REQUIRED,
} from '../../../../SharedModules/Errors/constantMessageData';
import {
  navigateToNextCell,
  onCellFocused,
  tabToNextCell,
} from '../../../../SharedModules/AgGridUtilities/suppressNavigation';
import {
  dispatchProviderListDetails,
  getProviderIdTypeDetails,
  getProviderList,
  searchProviderReqAction,
} from '../../../Display/Provider/store/action';
import { cellHead } from '../../../Display/Provider/Components/tableHead';

function NewProviderModal(props) {
  const { setSelectedRow, errorMessageList, setErrorMessageList } = props;
  const dispatch = useDispatch();
  const searchProvideridTypeDetail = (value) =>
    dispatch(getProviderIdTypeDetails(value));
  const payload = useSelector(
    (state) => state?.sharedState?.ProviderReducer?.providerIdType
  );
  const providerSeachList = useSelector(
    (state) => state?.sharedState?.ProviderReducer?.providerList
  );
  const providerData = useSelector(
    (state) => state?.sharedState?.ProviderReducer?.searchProviderRequest
  );

  const [selectedOption, setSelectedOption] = useState('NAME');
  const [providedID, setProviderID] = useState('ALL');
  const [providerName, setProviderName] = useState('');
  const [providerIdList, setProviderIdList] = useState([]);
  const [errorMessages, setErrorMessages] = useState([]);
  const [APIFailed, setAPIFailed] = useState(false);
  const [searchClicked, setSearchClicked] = useState(false);

  const childRef = useRef(null);
  const [gridApi, setGridApi] = useState(null);
  const [columnApi, setColumnApi] = useState(null);

  const onGridReady = useCallback((params) => {
    setGridApi(params.api);
    setColumnApi(params.columnApi);
  }, []);

  const handleChangeID = (e) => {
    setErrorMessages([]);
    setProviderID(e.target.value);
  };
  const handleChangeName = (e) => {
    setErrorMessages([]);
    setProviderName(e.target.value);
  };
  const onClickSearch = () => {
    setErrorMessages([]);
    setErrorMessageList([]);

    setSearchClicked(true);
    const data = {
  searchVal: providerName,
  searchBy: selectedOption || 'NAME',
  page: '0',
  pageSize: '100',
  providerIdTypeCd: providedID || 'ALL',
    };
    dispatch(getProviderList(data, setAPIFailed));
    dispatch(searchProviderReqAction(data));
  };
  const frameworkComponents = {
    nameRenderName: (cellInfo) => {
      const name = cellInfo.data && cellInfo.data.name;
      if (name && name.length > 29) {
        return (
          <OverlayTrigger
            placement="bottom"
            overlay={<Tooltip id="labeler-tooltip">{name}</Tooltip>}
          >
            <div>{name}</div>
          </OverlayTrigger>
        );
      }
      return <div>{name}</div>;
    },
  };

  useEffect(() => {
    searchProvideridTypeDetail({});
    dispatch(dispatchProviderListDetails([]));
    setProviderName('');
  }, []);

  useEffect(() => {
    if (
      !(
        providerSeachList &&
        providerSeachList.data &&
        providerSeachList.data[0]
      ) &&
      searchClicked
    ) {
      setErrorMessages([
        APIFailed ? FAILED_MESSAGE_GENERIC : NO_RESULT_FOUND_ERROR,
      ]);
      setSearchClicked(false);
      setAPIFailed(false);
    }
  }, [providerSeachList]);

  useEffect(() => {
    if (providerData && Object.keys(providerData).length > 0) {
      setProviderID(providerData.providerIdTypeCd ?? 'ALL');
      setProviderName(providerData.searchVal ?? '');
      setSelectedOption(providerData.searchBy ?? 'NAME');
    }
  }, [providerData]);

  const handleChange = (e) => {
    setErrorMessages([]);
    setSelectedOption(e.target.value);
  };

  useEffect(() => {
    const data = [
      {
        codeDomainKey: null,
        codeValue: null,
        codeValueID: {
          codeDomainKey: 'All',
          codeValue: 'all',
        },
      },
    ];
    if (providerIdList) {
      providerIdList.unshift(data);
    }
    setProviderIdList(payload);
  }, [payload]);

  const onSelectionChanged = useCallback(() => {
    setSelectedRow(gridApi.getSelectedRows());
  }, [gridApi]);

  return (
    <div className="tBillPanel custom-check">
      <div className="panel tBillPanel-space devider-line pb-0">
        <DisplayErrorMessages
          errorMessages={
            errorMessageList?.length > 0
              ? [...new Set(errorMessageList)]
              : [...new Set(errorMessages)]
          }
        />
        <div className="panel mb-3">
          <span style={{ color: '#274463' }}>
            Please Select Provider you would like to add:
          </span>
          <fieldset className="custom-fieldset" style={{ marginTop: 10 }}>
            <legend className="same-font-family">Search By</legend>
            <div className="row" style={{ margin: '-20px -10px -20px -35px' }}>
              <div className="col-sm-6">
                <div className="form-wrapper p-0 mt-2">
                  <div className="mui-custom-form input-md field-xl">
                    <div
                      className="sub-radio no-margin"
                      id="demo-row-radio-buttons-group-label"
                    >
                      <FormControl>
                        <RadioGroup
                          row
                          aria-labelledby="demo-row-radio-buttons-group-label"
                          name="row-radio-buttons-group"
                          value={selectedOption}
                          onChange={(e) => {
                            handleChange(e);
                          }}
                        >
                          <FormControlLabel
                            style={{ marginRight: '15px' }}
                            value="ID"
                            control={<Radio />}
                            label="Provider ID"
                            data-test="radio-all"
                          />
                          <FormControlLabel
                            style={{ marginRight: '15px' }}
                            value="NAME"
                            control={<Radio />}
                            label="Provider Name"
                            data-test="radio-Selected"
                          />
                        </RadioGroup>
                      </FormControl>
                    </div>
                  </div>
                </div>
              </div>
              <div
                className="col-sm-6"
                style={{ marginTop: 8 }}
                id="providerIdType"
              >
                <TextField
                  fullWidth
                  select
                  placeholder=""
                  required
                  inputProps={{ 'aria-labelledby': 'providerIdType' }}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  label="Provider ID Type"
                  name="providerIDType:"
                  value={providedID || 'ALL'}
                  onChange={handleChangeID}
                >
                  <MenuItem selected key="all" value="ALL">
                    ALL
                  </MenuItem>
                  {providerIdList &&
                  providerIdList.length &&
                  providerIdList.length > 0
                    ? providerIdList.map((item) => {
                        return (
                          <MenuItem
                            key={item.codeValueID.codeValue}
                            value={item.codeValueID.codeValue}
                            className="frr-logcheck-dropdown-item"
                          >
                            {`${item.codeValueID.codeValue}  ${item.shortDescription}`}
                          </MenuItem>
                        );
                      })
                    : null}
                </TextField>
              </div>
            </div>
          </fieldset>
          <div className="row">
            <div className="col-sm-6">
              <div className="form-wrapper p-0">
                <div
                  className="mui-custom-form with-select field-xl"
                  id="searchFor"
                >
                  <TextField
                    fullWidth
                    placeholder=""
                    value={providerName}
                    onChange={handleChangeName}
                    type="text"
                    label="Search For"
                    InputLabelProps={{
                      shrink: true,
                    }}
                    inputProps={{
                      maxLength: 40,
                      'aria-labelledby': 'searchFor',
                    }}
                  />
                </div>
              </div>
            </div>
            <div className="col-sm-4" style={{ marginTop: 14 }}>
              <div className="btn-wrapper mb-2">
                <div className="float-right mt-2 hide-on-print" tabIndex={0}>
                  <Button
                    className="btn btn-success btn-save"
                    onClick={onClickSearch}
                  >
                    {' '}
                    <SVGComponent iconName="Icon-search" />
                    Search
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="panel tBillPanel-space pb-0">
        <div className="FRR-custom-table tbl-manufacturer-home frr-tbl-with-feature">
          <TableGrid
            gridApi={gridApi}
            columnApi={columnApi}
            childRef={childRef}
            onGridReady={onGridReady}
            gridHeight={350}
            rowData={
              providerSeachList &&
              providerSeachList.data &&
              providerSeachList.data[0]
                ? providerSeachList.data
                : []
            }
            defaultCol={{ editable: false }}
            columnDefs={cellHead}
            navigateToNextCell={navigateToNextCell}
            // tabToNextCell={tabToNextCell}
            enterMovesDown
            suppressCellFocus
            onCellFocused={onCellFocused}
            exportFile
            data-testid="onEditingStopped"
            fileName="Provider"
            onSelectionChanged={onSelectionChanged}
            rowMultiSelectWithClick
            frameworkComponents={frameworkComponents}
          />
        </div>
      </div>
    </div>
  );
}
export default withRouter(NewProviderModal);
